import publicRoutes from "../../apiRoutes/publicRoutes";
import { api } from "../ConsumeApiController";

export async function getMerchantData(uuid)
{
    const response = await api.get(publicRoutes.merchant.profile(uuid));
    return response;
}